import { useSearchParams } from "react-router-dom";

export const getQueryParams = ({
  prefix = "",
  defaultOrderBy = "name",
  defaultSortOrder = "asc",
  include = [],
  pagination = true,
}) => {
  const [search] = useSearchParams();

  const orderBy = search.get(`${prefix}orderBy`) || defaultOrderBy;
  const sortOrder = search.get(`${prefix}sortOrder`) || defaultSortOrder;
  const limit = search.get(`${prefix}limit`) || 100;
  const offset = search.get(`${prefix}offset`) || 0;

  const includeKeys = include?.reduce((tol, [key, defaultValue]) => {
    const value = search.get(key) || defaultValue;
    if (value && value != "All") tol[key] = value;
    return tol;
  }, {});

  const paginationProps = pagination
    ? { limit, offset, orderBy, sortOrder }
    : {};

  const queryProps = {
    ...paginationProps,
    ...includeKeys,
  };

  return queryProps;
};
